import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@shared/components/ui/dialog";
import { Button } from "@shared/components/ui/button";

interface BannerSectionProps {
  bannerImage: string;
  bannerURL?: string;
}

export default function BannerSection({ bannerImage, bannerURL }: BannerSectionProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("booking");

  return (
    <>
      <div>
        <figure className="relative mx-auto overflow-hidden rounded-xl">
          <img
            src={bannerImage}
            alt={t("BANNER_IMAGE_ALT")}
            className="w-full rounded-xl object-cover"
          />
          {bannerURL && (
            <button
              type="button"
              aria-label={t("VIEW_BANNER_DETAILS")}
              className="absolute right-4 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-brand text-brand-foreground shadow-lg transition-opacity hover:opacity-80"
              onClick={() => setOpen(true)}
            >
              <ArrowRight size={18} />
            </button>
          )}
        </figure>
      </div>

      {bannerURL && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="max-w-md p-0 overflow-hidden">
            <DialogTitle className="sr-only">Banner</DialogTitle>
            <img
              src={bannerImage}
              alt={t("BANNER_IMAGE_ALT")}
              className="w-full object-cover"
            />
            <div className="flex flex-col gap-2 p-4">
              <Button
                className="w-full bg-brand hover:bg-brand-dark text-brand-foreground"
                onClick={() => window.open(bannerURL, "_blank")}
              >
                {t("NEW_HOME_RESERVE_EVENT")}
              </Button>
              <Button
                variant="outline"
                className="w-full"
                onClick={() => setOpen(false)}
              >
                {t("NEW_HOME_CLOSE")}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
